module.exports = __webpack_public_path__ + "assets/svg/Icons/32/attachment-gray-24077a.svg";